export default 'tagsPage';
